import { Serializers, SerializerValue } from "@megaron/serializers";

export const ticketStatuses = ["new", "open", "resolved", "closed"] as const;
export type TicketStatus = (typeof ticketStatuses)[number];

export const priorities = ["low", "medium", "high", "urgent"] as const;
export type Priority = (typeof priorities)[number];

export const ticketCategories = ["complaint", "question"] as const;
export type TicketCategory = (typeof ticketCategories)[number];

export const supportTicketSortFields = ["createdAt", "updatedAt", "priority"] as const;
export type SupportTicketSortField = (typeof supportTicketSortFields)[number];

export const supportTicketSortOrders = ["ASC", "DESC"] as const;
export type SupportTicketSortOrder = (typeof supportTicketSortOrders)[number];

export const supportTicketFiltersSerializer = Serializers.object({
  page: Serializers.integer,
  searchText: Serializers.string,
  status: Serializers.stringOneOf(...ticketStatuses)
    .array()
    .asJsonString(),
  priority: Serializers.stringOneOf(...priorities)
    .array()
    .asJsonString(),
  category: Serializers.stringOneOf(...ticketCategories)
    .array()
    .asJsonString(),
  tags: Serializers.string.array().asJsonString(),
  sort: Serializers.stringOneOf(...supportTicketSortFields),
  sortOrder: Serializers.stringOneOf(...supportTicketSortOrders),
  myTickets: Serializers.boolean,
  isRead: Serializers.boolean,
}).partial();

export type SupportTicketFilters = SerializerValue<typeof supportTicketFiltersSerializer>;
